import { MessageCircle, HeartHandshake, Anchor, Route } from "lucide-react";
import { Reveal } from "./Reveal";

const struggles = [
  {
    icon: MessageCircle,
    title: "Communication",
    copy: "When every talk turns into a fight — or worse, silence. We help you learn to hear each other again.",
    span: "md:col-span-7",
    bg: "bg-[#F3EFEA]",
  },
  {
    icon: HeartHandshake,
    title: "Trust",
    copy: "Broken trust doesn't have to be the end of the story. Rebuilding it is slow, honest work — and it's possible.",
    span: "md:col-span-5",
    bg: "bg-[#E6DFD5]/60",
  },
  {
    icon: Anchor,
    title: "Commitment",
    copy: "One foot out the door? We've been there. Recommitting starts with a decision, not a feeling.",
    span: "md:col-span-5",
    bg: "bg-[#E6DFD5]/60",
  },
  {
    icon: Route,
    title: "Separation",
    copy: "We separated once too — and found our way back. If you're apart, there is still a road home.",
    span: "md:col-span-7",
    bg: "bg-[#F3EFEA]",
  },
];

export const Struggles = () => (
  <section id="struggles" className="py-24 lg:py-32" data-testid="struggles-section">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <Reveal>
        <p className="text-xs uppercase tracking-[0.25em] text-[#8A5A44] mb-4">01 — Where we meet you</p>
        <h2 className="font-serif-display text-4xl sm:text-5xl font-medium tracking-tight text-[#2C2A28] max-w-2xl">
          If any of this sounds like <em className="italic text-[#8A5A44]">home</em>, we should talk.
        </h2>
      </Reveal>

      <div className="grid grid-cols-1 md:grid-cols-12 gap-8 lg:gap-10 mt-16">
        {struggles.map((s, i) => (
          <Reveal key={s.title} delay={i * 0.08} className={s.span}>
            <div
              className={`${s.bg} rounded-3xl p-10 lg:p-12 h-full border border-black/5 transition-[transform,box-shadow] duration-500 hover:-translate-y-1 hover:shadow-[0_12px_40px_rgb(0,0,0,0.07)]`}
              data-testid={`struggle-card-${s.title.toLowerCase()}`}
            >
              <s.icon size={28} strokeWidth={1.5} className="text-[#8A5A44]" />
              <h3 className="font-serif-display text-2xl md:text-3xl font-medium text-[#2C2A28] mt-6">
                {s.title}
              </h3>
              <p className="text-[#5C5854] leading-relaxed font-light mt-3 max-w-md">{s.copy}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
